// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"67d8bbb3","114":"8e425fc0","146":"bb8feeb4","163":"376b5d47","226":"6d568bc1","462":"f4b10531","547":"727c9d25","638":"814472b8","657":"76d5b707","852":"4f182ff6","967":"b1dcaaec"}[chunkId] + ".chunk.js";
};